import { css, styled } from '@mui/material'
import { NAVIGATION_BAR_HEIGHT } from 'redesign/components/organisms/NavigationBarContent/constants'
import { SHIFT_PLAN_HEADER_HEIGHT } from 'redesign/components/organisms/headers/ShiftPlanHeader/constants'
import { VirtualizeSwipeableViews } from 'redesign/services/SwipeableView/VirtualizeSwipeableViews'

export const Container = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  width: 100%;
`

export const EmptyPageContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  width: 100%;
  position: fixed;
  height: 100%;
  box-sizing: border-box;
  margin: ${({ theme }) => theme.spacing(-3, 0)}; // This is to account for the padding of the SwipeableViews
`

export const SwipeableViews = styled(VirtualizeSwipeableViews)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};
  flex-grow: 1;
  height: 100%;
  & > div {
    height: 100%;
    min-height: ${({ theme }) => theme.spacing(48)};
  }
`

export const SwipeableContainer = styled('div')<{ slide: number; index: number }>`
  ${({ theme, slide, index }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(3)};
    pointer-events: auto;

    ${slide === index
      ? css`
          height: auto;
          overflow: visible;
        `
      : css`
          // Calculating height of adjacent slides to not exceed the height of the screen
          // It is accounting for the height of the navbar and header of the page
          height: calc(
            100vh - ${theme.spacing(NAVIGATION_BAR_HEIGHT)} - ${theme.spacing(SHIFT_PLAN_HEADER_HEIGHT)} -
              var(--ion-safe-area-top) - var(--ion-safe-area-bottom)
          );
          margin: ${theme.spacing(0, 2)};
        `}
  `}
`

export const DataContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};
  padding: ${({ theme }) => theme.spacing(3, 0)};
`
